export default __webpack_public_path__ + "static/media/expU.e77f0e91.png";